import { call, fork, take, put } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'
import i18n from 'i18next'
import { LinkedInPostApi } from '../../api/instances'
import { Severity, EventType } from '@professocial/professocialTypes/types/messageTypes'
import { requestFailed, requestFinished, requestStarted } from '../common/common.actions'
import { GetLinkedInFeedRequest } from '@3m5/sm_publish-frontend-api/apis/LinkedInPostApi'
import { getLinkedInFeed, getLinkedInFeedInitiated } from './linkedIn.actions'



// loadLinkedInFeedForPage
const loadLinkedInFeedForPageWorker = bindAsyncAction(getLinkedInFeed)(
  function * (params: GetLinkedInFeedRequest) {
    return yield call([LinkedInPostApi, LinkedInPostApi.getLinkedInFeed], params)
  },
)

function * watchLoadLinkedInFeedForPageInitiated () {
  while (true) {
    const action: Action<GetLinkedInFeedRequest> = yield take(getLinkedInFeedInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield loadLinkedInFeedForPageWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('postMessages:loadingError', { context: i18n.t('postCommon:posts') }),
          eventType: EventType.load,
        },
      }))
      console.error('error in watchLoadLinkedInFeedForPageInitiated: ', e)
    }
  }
}


export function * linkedInSagas () {
  yield fork(watchLoadLinkedInFeedForPageInitiated)
}
